import Backbone from 'backbone';

var Mobel_Project_Domain = Backbone.Model.extend({
    defaults: {
        account_id     : 0,
        project_id     : 0,
        url            : '',
        domain         : '',
        session_replay :  false
    }
});

export default Mobel_Project_Domain;